
export const townName = process.env.VUE_APP_MUNICIPALITY